import { noop } from 'lodash'

interface Haptic {
  impactLight: () => void
  impactMedium: () => void
  impactHeavy: () => void
  rigid: () => void
  soft: () => void
  notificationSuccess: () => void
  notificationWarning: () => void
  notificationError: () => void
}

export class HapticAdapter {
  impactLight: () => void
  impactMedium: () => void
  impactHeavy: () => void
  rigid: () => void
  soft: () => void
  notificationSuccess: () => void
  notificationWarning: () => void
  notificationError: () => void

  constructor(methods?: Haptic) {
    this.impactLight = methods?.impactLight ?? noop
    this.impactMedium = methods?.impactMedium ?? noop
    this.impactHeavy = methods?.impactHeavy ?? noop
    this.rigid = methods?.rigid ?? noop
    this.soft = methods?.soft ?? noop
    this.notificationSuccess = methods?.notificationSuccess ?? noop
    this.notificationWarning = methods?.notificationWarning ?? noop
    this.notificationError = methods?.notificationError ?? noop
  }
}
